import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';

import type { NavGroup } from '~/interfaces/publication';

import NavGroupContainer from './NavGroupContainer';
import NavGroupListContainer from './NavGroupListContainer';
import ThemedNavGroupLink from './ThemedNavGroupLink';
import ThemedNavGroupTitle from './ThemedNavGroupTitle';

interface Props {
  navGroups: NavGroup[];
}

const NavGroups = ({ navGroups }: Props) => {
  const { webTheme } = useWebThemeContext();

  return (
    <>
      {navGroups.map((group: NavGroup) => {
        const isCategoryGroup = group.is_category_group;

        if (isCategoryGroup) {
          return null;
        }

        const navLinksLength = group?.nav_links?.length;
        if (!navLinksLength) return null;

        return (
          <NavGroupContainer key={group.id}>
            <ThemedNavGroupTitle text={group.title} />
            <NavGroupListContainer>
              {group?.nav_links?.map((link) => {
                const isExternalLink = link.external_link;

                if (isExternalLink) {
                  return (
                    <a
                      style={{
                        ...(webTheme.footer_external_link_underline_color && {
                          color: webTheme.footer_external_link_underline_color,
                        }),
                      }}
                      key={link.id}
                      href={link.href}
                      target="_blank"
                      rel="nofollow noreferrer noopener"
                      className="underline"
                    >
                      <ThemedNavGroupTitle text={link.cta_text} color={webTheme?.footer_external_link_color} />
                    </a>
                  );
                }

                return <ThemedNavGroupLink key={link.id} path={`/c/${link.href}`} text={link.cta_text} />;
              })}
            </NavGroupListContainer>
          </NavGroupContainer>
        );
      })}
    </>
  );
};

export default NavGroups;
